import type React from "react";
import "./PrivacyPolicy.scss";
import ContactForm from "../../common-ui/contact-form/ContactForm";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        {/* Header */}
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
        </header>

        {/* Columns */}
        <div className="privacy-columns">
          {/* Left Column - Content */}
          <main className="privacy-content">
            <p className="intro">
              At <strong>Hot Freight International</strong> (“we,” “our,” or
              “us”), we value and respect your privacy. This Privacy Policy
              explains how we collect, use, share, and protect your personal
              information when you interact with our website or services.
            </p>

            <div className="policy-section">
              <h2>Information We Collect</h2>
              <p>
                We may collect personal information in several ways:
                <br />
                <strong>Directly from you:</strong> when you browse our website,
                register for an account, purchase services, subscribe to
                updates, attend events, or communicate with our sales, finance,
                operations, or marketing teams.
                <br />
                <strong>Automatically:</strong> when you use our website, we may
                collect data through cookies, scripts, and other tracking
                technologies.
                <br />
                <strong>From other sources:</strong> such as publicly available
                information or third-party partners.
              </p>
            </div>

            <div className="policy-section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide and improve our services</li>
                <li>Inform you of updates or changes</li>
                <li>Enable participation in interactive features</li>
                <li>Offer customer support</li>
                <li>Analyze website performance and usage</li>
                <li>Detect and prevent fraud or technical issues</li>
                <li>Meet legal and regulatory requirements</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>Personal Information You Provide</h2>
              <p>
                This may include your name, address, email, phone number,
                employment information, or payment details such as credit card
                or account numbers.
              </p>
            </div>

            <div className="policy-section">
              <h2>Information Collected Automatically</h2>
              <p>
                This may include your IP address, browser type, device details,
                date and time of your visit, and pages viewed. We collect this
                data to improve site performance and security.
              </p>
            </div>

            <div className="policy-section">
              <h2>Your Consent</h2>
              <p>
                By using our website, you agree to this Privacy Policy. You may
                withdraw your consent at any time by contacting us, though some
                services may not be available without certain information.
              </p>
            </div>

            <div className="contact-section">
              <h2>Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy or how your data
                is handled, please reach out to us:
              </p>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-icon">✉</span>
                  <a href="mailto:info@shiphotfreight.com">
                    info@shiphotfreight.com
                  </a>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <span>905-363-1865</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <span>3580 Odyssey Drive, Mississauga, ON L5M 0Z9</span>
                </div>
              </div>
            </div>
          </main>

          {/* Right Column - Form */}
          <aside className="privacy-form">
            <div className="form-container">
              <h2 className="form-heading">
                Have Questions About Our Privacy Policy?
              </h2>
              <p className="form-subheading">
                Contact our privacy team for more information.
              </p>
              <ContactForm />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
